export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12663.903d2b9f.jpg";